export default __webpack_public_path__ + "static/media/lesnik_summer_07.732425af.svg";